"use strict";

exports.__esModule = true;
exports.UNPARSEABLE_TAGS = exports.TYPEDARRAY_TAGS = exports.TOSTRING_TAGS = exports.SELF_TAGS = exports.PRIMITIVE_TAGS = exports.ITERABLE_TAGS = exports.OBJECT_CLASS_TYPE_MAP = exports.OBJECT_CLASS_MAP = exports.SVG_ELEMENT_REGEXP = exports.HTML_ELEMENT_REGEXP = exports.HAS_UINT16ARRAY_SUPPORT = exports.HAS_BUFFER_FROM_SUPPORT = void 0;

var _SELF_TAGS, _TOSTRING_TAGS, _TYPEDARRAY_TAGS, _UNPARSEABLE_TAGS;

/**
 * @constant {boolean} HAS_BUFFER_FROM_SUPPORT
 */
var HAS_BUFFER_FROM_SUPPORT = typeof Buffer !== 'undefined' && typeof Buffer.from === 'function';
/**
 * @constant {boolean} HAS_UINT16ARRAY_SUPPORT
 */

exports.HAS_BUFFER_FROM_SUPPORT = HAS_BUFFER_FROM_SUPPORT;
var HAS_UINT16ARRAY_SUPPORT = typeof Uint16Array === 'function';
/**
 * @constant {RegExp} HTML_ELEMENT_REGEXP
 */

exports.HAS_UINT16ARRAY_SUPPORT = HAS_UINT16ARRAY_SUPPORT;
var HTML_ELEMENT_REGEXP = /\[object (HTML(.*)Element)\]/;
/**
 * @constant {RegExp} SVG_ELEMENT_REGEXP
 */

exports.HTML_ELEMENT_REGEXP = HTML_ELEMENT_REGEXP;
var SVG_ELEMENT_REGEXP = /\[object (SVG(.*)Element)\]/;
/**
 * @constant {Array<string>} OBJECT_CLASSES
 */

exports.SVG_ELEMENT_REGEXP = SVG_ELEMENT_REGEXP;
var OBJECT_CLASSES = ['Arguments', 'Array', 'ArrayBuffer', 'Boolean', 'DataView', 'Date', 'DocumentFragment', 'Error', 'Event', 'Float32Array', 'Float64Array', 'Function', 'Generator', 'GeneratorFunction', 'HTMLElement', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Null', 'Number', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'Undefined', 'WeakMap', 'WeakSet', 'Window'];
/**
 * @constant {Object} OBJECT_CLASS_MAP
 */

var OBJECT_CLASS_MAP = OBJECT_CLASSES.reduce(function (objectClasses, type) {
  objectClasses["[object " + type + "]"] = type;
  return objectClasses;
}, {});
/**
 * @constant {Object} OBJECT_CLASS_TYPE_MAP
 */

exports.OBJECT_CLASS_MAP = OBJECT_CLASS_MAP;
var OBJECT_CLASS_TYPE_MAP = Object.keys(OBJECT_CLASS_MAP).reduce(function (objectClassTypes, objectClass) {
  objectClassTypes[OBJECT_CLASS_MAP[objectClass].toUpperCase()] = objectClass;
  return objectClassTypes;
}, {});
exports.OBJECT_CLASS_TYPE_MAP = OBJECT_CLASS_TYPE_MAP;
var ITERABLE_TAGS = {
  '[object Map]': true,
  '[object Set]': true
};
exports.ITERABLE_TAGS = ITERABLE_TAGS;
var PRIMITIVE_TAGS = {
  boolean: true,
  function: true,
  number: true,
  string: true,
  undefined: true
};
exports.PRIMITIVE_TAGS = PRIMITIVE_TAGS;
var SELF_TAGS = (_SELF_TAGS = {}, _SELF_TAGS[OBJECT_CLASS_TYPE_MAP.ARGUMENTS] = true, _SELF_TAGS[OBJECT_CLASS_TYPE_MAP.ARRAY] = true, _SELF_TAGS);
exports.SELF_TAGS = SELF_TAGS;
var TOSTRING_TAGS = (_TOSTRING_TAGS = {}, _TOSTRING_TAGS[OBJECT_CLASS_TYPE_MAP.REGEXP] = true, _TOSTRING_TAGS[OBJECT_CLASS_TYPE_MAP.SYMBOL] = true, _TOSTRING_TAGS);
exports.TOSTRING_TAGS = TOSTRING_TAGS;
var TYPEDARRAY_TAGS = (_TYPEDARRAY_TAGS = {}, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.FLOAT32ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.FLOAT64ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.INT8ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.INT16ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.INT32ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.UINT8ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.UINT8CLAMPEDARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.UINT16ARRAY] = true, _TYPEDARRAY_TAGS[OBJECT_CLASS_TYPE_MAP.UINT32ARRAY] = true, _TYPEDARRAY_TAGS);
exports.TYPEDARRAY_TAGS = TYPEDARRAY_TAGS;
var UNPARSEABLE_TAGS = (_UNPARSEABLE_TAGS = {}, _UNPARSEABLE_TAGS[OBJECT_CLASS_TYPE_MAP.GENERATOR] = true, _UNPARSEABLE_TAGS[OBJECT_CLASS_TYPE_MAP.PROMISE] = true, _UNPARSEABLE_TAGS[OBJECT_CLASS_TYPE_MAP.WEAKMAP] = true, _UNPARSEABLE_TAGS[OBJECT_CLASS_TYPE_MAP.WEAKSET] = true, _UNPARSEABLE_TAGS);
exports.UNPARSEABLE_TAGS = UNPARSEABLE_TAGS;